import { createStore } from 'vuex';
import project from './schedule/project';
import team from './schedule/team';
import person from './schedule/person';
import planning from './planning';
import planningFilter from './planning/planningFilter';
import permissions from './permissions';
import VuexEventListenerPlugin from '../plugins/VuexEventListenerPlugin';
import { emitter } from '../plugins/Mitt';

// Initialize Vuex Event Listener Plugin
const EventListenerPlugin = VuexEventListenerPlugin(emitter);

const store = createStore({
    modules: {
        project,
        team,
        person,
        planning,
        planningFilter,
        permissions,
    },
    plugins: [EventListenerPlugin],
    strict: process.env.NODE_ENV !== 'production', // Enable strict mode only in development
});

export default store;